import { render, staticRenderFns } from "./ProductNewView.vue?vue&type=template&id=2ca2e518&scoped=true"
import script from "./ProductNewView.vue?vue&type=script&lang=js"
export * from "./ProductNewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2e518",
  null
  
)

export default component.exports